export default __webpack_public_path__ + "static/media/slide-2.328cf461.webp";